module.exports = __webpack_public_path__ + "img/current-integral.cf40dae0.png";